export const initialState = {
  actionProcessing: false,
  statisticProvider: {
    providers: [],
    detail: {
      betCount: 0,
      betAmount: 0,
      winAmount: 0,
      incomeAmount: 0,
      commissionBalance: 0,
      lastCalculateTime: '',
      margin: 0,
      /* isOutdated: false, */
    },
    diff: {
      betCount: '0',
      betCountPercent: 0,
      betAmount: '0',
      betAmountPercent: 0,
      winAmount: '0',
      winAmountPercent: 0,
      incomeAmount: '0',
      incomeAmountPercent: 0,
      commissionBalance: '0',
      commissionBalancePercent: 0,
      margin: '0',
    },
    providersDiff: {},
  },
  paymentHistory: {
    transfers: [],
    details: {
      totalCount: 0,
      totalDeposit: 0,
      totalWithdraw: 0,
      deltaBalance: 0,
      lastCalculateTime: '',
    },
  },
  cashbackHistory: {
    data: [],
    count: 0,
    paid: 0,
    toBePaid: 0,
    accumulated: 0,
  },
  paymentHistoryTotals: {
    totalDeposit: 0,
    totalWithdraw: 0,
    deltaBalance: 0,
    balance: 0,
  },
  statisticPlayer: {
    userStatistic: [],
    details: {
      totalCount: 0,
    },
  },
  slotsHistory: {
    data: [],
    totalCount: 0,
  },
  betsHistory: {
    data: [],
    count: 0,
  },
  playerDeposits: {
    data: [],
    count: 0,
    cbu: '',
  },
  requestHistory: {
    data: [],
    count: 0,
  },
};
